import React, { useEffect, useState } from 'react';

// Walkthrough playback-style selector (BL-147). Two cards — Default (guided
// framed screenshot) and Spotlight (dimmed page + spotlighted element). Renders
// inside the Appearance panel via DesignOption's `playback` type; persists the
// choice to the walkthrough config (pb.pbStyle = 'default' | 'spotlight').

const ACC = '#0E7C86';

const DefaultThumb = () => (
  <span style={{ position: 'relative', display: 'block', width: 74, height: 52, borderRadius: 8, border: '1px solid #D7DFE3', background: '#fff', overflow: 'hidden' }}>
    <span style={{ position: 'absolute', left: 0, right: 0, top: 0, height: 11, background: '#F1F4F6', borderBottom: '1px solid #E7ECEF' }} />
    <span style={{ position: 'absolute', left: 6, top: 4, width: 4, height: 4, borderRadius: '50%', background: '#D6DEE2' }} />
    <span style={{ position: 'absolute', left: 8, top: 18, right: 8, bottom: 16, background: '#E9EEF1', borderRadius: 3 }} />
    <span style={{ position: 'absolute', left: 8, bottom: 6, display: 'flex', gap: 3 }}>
      <i style={{ width: 12, height: 4, borderRadius: 2, background: ACC, display: 'block' }} />
      <i style={{ width: 4, height: 4, borderRadius: 2, background: '#D7DFE3', display: 'block' }} />
      <i style={{ width: 4, height: 4, borderRadius: 2, background: '#D7DFE3', display: 'block' }} />
    </span>
  </span>
);

const SpotlightThumb = () => (
  <span style={{ position: 'relative', display: 'block', width: 74, height: 52, borderRadius: 8, border: '1px solid #D7DFE3', overflow: 'hidden', background: '#20303A' }}>
    <span style={{ position: 'absolute', left: 8, top: 8, right: 8, bottom: 8, background: '#33454F', borderRadius: 3, opacity: 0.5 }} />
    <span style={{ position: 'absolute', left: 14, top: 12, width: 20, height: 20, borderRadius: '50%', background: '#fff', boxShadow: `0 0 0 3px ${ACC}` }} />
    <span style={{ position: 'absolute', right: 8, bottom: 8, width: 34, height: 18, background: '#fff', borderRadius: 3 }} />
  </span>
);

const Radio = ({ on }) => (
  <span style={{ width: 18, height: 18, flex: 'none', borderRadius: '50%', border: `1.5px solid ${on ? ACC : '#C2CBD1'}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    {on ? <i style={{ width: 9, height: 9, borderRadius: '50%', background: ACC, display: 'block' }} /> : null}
  </span>
);

const OPTIONS = [
  { value: 'default', label: 'Default', thumb: <DefaultThumb />, desc: 'Guided view — the screenshot in a frame with step progress and Next.' },
  { value: 'spotlight', label: 'Spotlight', thumb: <SpotlightThumb />, desc: 'Dims the page and highlights each element in place with a tooltip.' }
];

const PlaybackStyleOption = ({ defaultValue, onChange }) => {
  const [value, setValue] = useState(defaultValue === 'spotlight' ? 'spotlight' : 'default');
  useEffect(() => { setValue(defaultValue === 'spotlight' ? 'spotlight' : 'default'); }, [defaultValue]);

  const pick = (v) => {
    setValue(v);
    onChange(v);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
      {OPTIONS.map((o) => {
        const on = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => pick(o.value)}
            style={{
              display: 'flex', gap: 12, alignItems: 'center', width: '100%', textAlign: 'left',
              padding: 12, borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit',
              border: on ? `1.5px solid ${ACC}` : '0.5px solid #D7DFE3',
              background: on ? 'rgba(14,124,134,0.06)' : '#fff'
            }}
          >
            {o.thumb}
            <span style={{ flex: 1 }}>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 700, fontSize: 14, color: '#16232E' }}>{o.label}</span>
                <Radio on={on} />
              </span>
              <span style={{ display: 'block', fontSize: 12, lineHeight: 1.4, color: '#5A6B7E', marginTop: 3 }}>{o.desc}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default PlaybackStyleOption;
